import { PublicProductFormRegistrationRoute } from './PublicRegistrationFormRoute';
import { withPublicFormsMachine } from './withPublicFormsMachine';

const PublicRegistrationFormRouteWithMachine = withPublicFormsMachine(
  PublicProductFormRegistrationRoute
);
export {
  PublicProductFormRegistrationRoute,
  PublicRegistrationFormRouteWithMachine,
  withPublicFormsMachine
};
